import { get } from "./api";
import URLS from "../constants/api";

export const getNotifications = async (
) => {

  const response = await get(URLS.NOTIFICATIONS);
  return response;
};
